import { render, staticRenderFns } from "./error404PC.vue?vue&type=template&id=6a2f565a&scoped=true"
import script from "./error404PC.vue?vue&type=script&lang=js"
export * from "./error404PC.vue?vue&type=script&lang=js"
import style0 from "./error404PC.vue?vue&type=style&index=0&id=6a2f565a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2f565a",
  null
  
)

export default component.exports